var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, Fragment, useEffect } from 'react';
import { createControllerBox, createEffectHook, useFormEffects, useFieldState } from '@formily/react-schema-renderer';
import { toArr } from '@formily/shared';
import { Steps } from 'antd';
import { createMatchUpdate } from '../shared';
var StateMap;
(function (StateMap) {
    StateMap["ON_FORM_STEP_NEXT"] = "onFormStepNext";
    StateMap["ON_FORM_STEP_PREVIOUS"] = "onFormStepPrevious";
    StateMap["ON_FORM_STEP_GO_TO"] = "onFormStepGoto";
    StateMap["ON_FORM_STEP_CURRENT_CHANGE"] = "onFormStepCurrentChange";
    StateMap["ON_FORM_STEP_DATA_SOURCE_CHANGED"] = "onFormStepDataSourceChanged";
})(StateMap || (StateMap = {}));
var EffectHooks = {
    onStepNext$: createEffectHook(StateMap.ON_FORM_STEP_NEXT),
    onStepPrevious$: createEffectHook(StateMap.ON_FORM_STEP_PREVIOUS),
    onStepGoto$: createEffectHook(StateMap.ON_FORM_STEP_GO_TO),
    onStepCurrentChange$: createEffectHook(StateMap.ON_FORM_STEP_CURRENT_CHANGE)
};
export var FormStep = createControllerBox('step', function (_a) {
    var form = _a.form, schema = _a.schema, path = _a.path, name = _a.name, children = _a.children;
    var _b = schema.getExtendsComponentProps(), dataSource = _b.dataSource, stepProps = __rest(_b, ["dataSource"]);
    var _c = useFieldState({
        current: stepProps.current || 0
    }), current = _c[0].current, setFieldState = _c[1];
    var ref = useRef(current);
    var itemsRef = useRef([]);
    itemsRef.current = toArr(dataSource);
    var matchUpdate = createMatchUpdate(name, path);
    var update = function (cur) {
        form.notify(StateMap.ON_FORM_STEP_CURRENT_CHANGE, {
            path: path,
            name: name,
            value: cur,
            preValue: current
        });
        setFieldState({
            current: cur
        });
    };
    useEffect(function () {
        form.notify(StateMap.ON_FORM_STEP_DATA_SOURCE_CHANGED, {
            path: path,
            name: name,
            value: itemsRef.current
        });
    }, [itemsRef.current.length]);
    useFormEffects(function ($, _a) {
        var setFieldState = _a.setFieldState;
        var updateFields = function () {
            itemsRef.current.forEach(function (_a, index) {
                var name = _a.name;
                setFieldState(name, function (state) {
                    state.display = index === current;
                });
            });
        };
        updateFields();
        $(StateMap.ON_FORM_STEP_DATA_SOURCE_CHANGED).subscribe(function (_a) {
            var name = _a.name, path = _a.path;
            matchUpdate(name, path, function () {
                updateFields();
            });
        });
        $(StateMap.ON_FORM_STEP_CURRENT_CHANGE).subscribe(function (_a) {
            var _b = _a === void 0 ? {} : _a, value = _b.value, name = _b.name, path = _b.path;
            matchUpdate(name, path, function () {
                form.hostUpdate(function () {
                    itemsRef.current.forEach(function (_a, index) {
                        var name = _a.name;
                        if (!name)
                            throw new Error('FormStep dataSource must include `name` property');
                        setFieldState(name, function (state) {
                            state.display = index === value;
                        });
                    });
                }, true);
            });
        });
        $(StateMap.ON_FORM_STEP_NEXT).subscribe(function (_a) {
            var _b = _a === void 0 ? {} : _a, name = _b.name, path = _b.path;
            matchUpdate(name, path, function () {
                form.validate().then(function (_a) {
                    var errors = _a.errors;
                    if (errors.length === 0) {
                        update(ref.current + 1 > itemsRef.current.length - 1
                            ? ref.current
                            : ref.current + 1);
                    }
                });
            });
        });
        $(StateMap.ON_FORM_STEP_PREVIOUS).subscribe(function (_a) {
            var _b = _a === void 0 ? {} : _a, name = _b.name, path = _b.path;
            matchUpdate(name, path, function () {
                update(ref.current - 1 < 0 ? ref.current : ref.current - 1);
            });
        });
        $(StateMap.ON_FORM_STEP_GO_TO).subscribe(function (_a) {
            var _b = _a === void 0 ? {} : _a, name = _b.name, path = _b.path, value = _b.value;
            matchUpdate(name, path, function () {
                if (!(value < 0 || value > itemsRef.current.length)) {
                    update(value);
                }
            });
        });
    });
    ref.current = current;
    return (React.createElement(Fragment, null,
        React.createElement(Steps, __assign({}, stepProps, { current: current }), itemsRef.current.map(function (props, key) {
            return React.createElement(Steps.Step, __assign({}, props, { key: key }));
        })),
        ' ',
        children));
});
Object.assign(FormStep, StateMap, EffectHooks);
export default FormStep;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd-components/esm/form-step/index.js
// module id = 6301
// module chunks = 0